export const address = '45/2 Manivilas garden 3rd main road, kamalanagar Bangalore-560079'
export const website_name = 'IGPH Kamalanagar'
export const mobile_no ='91 9482642124'
export const email ='iphkamalanagar@gmail.com'


export const facebook_id ='https://www.facebook.com/IGPHKamalanagar/'
export const instagram_id ='https://www.instagram.com/igph_kamalanagar/'
export const twitter_id =''
export const whatsapp_id ='https://wa.me/919482642124?text=Hello'
export const youtube_id ='https://www.youtube.com/@igphkamalanagar-official3875'


export const primaryColor = '#ed883d'